import * as React from 'react';
import * as moment from 'moment-timezone';
import WeeklyExpandedEvent from '../WeeklyExpandedEvent';
import ExpandedTitle from '../ExpandedTitle';
import FocusTrap from '../FocusTrap/FocusTrap';
import { CalendarPopover } from 'wix-ui-tpa';
import { useTranslation } from 'react-i18next';
import Popper from '@material-ui/core/Popper';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import { st, classes } from './WeeklyPopper.st.css';
import PopupPositionEnum from '../../../enums/PopupPositionEnum';
//utils
import { getClickPosition, getPosition, } from '../../../utils/popupPositionUtils';
import getAccessRoleAndCalendarName from '../../../utils/getAccessRoleAndCalendarName';
import WeeklyContext from '../../../context/weeklyContext';
import getTitleToDisplay from '../../../utils/getTitleToDisplay';
import { DEMO_CALENDARS_IDS } from '../../../constants';
var WeeklyPopper = function (_a) {
    var open = _a.open, anchorEl = _a.anchorEl, event = _a.event, handleCloseClick = _a.handleCloseClick, handleClickAway = _a.handleClickAway, isCloseFocused = _a.isCloseFocused;
    var t = useTranslation()[0];
    var _b = React.useState(''), clickPosition = _b[0], setClickPosition = _b[1];
    var _c = React.useContext(WeeklyContext), isMobile = _c.isMobile, calendarsList = _c.calendarsList, firstDay = _c.firstDay, privetEventsTitle = _c.privetEventsTitle, timeFormat = _c.timeFormat, onCopyClick = _c.onCopyClick, onLocationClick = _c.onLocationClick, onAttachmentClick = _c.onAttachmentClick, weekStarter = _c.weekStarter, experiments = _c.experiments, locale = _c.locale;
    var extendedProps = event.extendedProps, allDay = event.allDay;
    var summary = extendedProps.summary;
    var calendarId = extendedProps.calendarId, title = extendedProps.title;
    var _d = getAccessRoleAndCalendarName(calendarsList, calendarId), accessRole = _d.accessRole, calendarName = _d.calendarName;
    var dayOfWeek = moment(event.start).day(); // not for all day events
    var _e = getPosition(firstDay, dayOfWeek, clickPosition), marginStyle = _e.marginStyle, popoverLocation = _e.popoverLocation;
    if (allDay) {
        marginStyle = 'marginTop';
        //@ts-ignore
        popoverLocation = PopupPositionEnum.BOTTOM_START;
    }
    var useStyles = makeStyles(function (theme) {
        var _a;
        return createStyles({
            root: {
                width: 500,
            },
            Popper: (_a = {}, _a['z-index'] = '9999', _a[marginStyle] = '4px', _a), //  margin shold be dinamic on position
        });
    });
    var styles = useStyles();
    React.useEffect(function () {
        var setClickPositionListener = function (e) {
            var position = getClickPosition(e.pageY);
            if (typeof position !== undefined) {
                setClickPosition(position);
            }
            else {
                setClickPosition('');
            }
        };
        document.addEventListener('click', setClickPositionListener);
        return function () {
            return document.removeEventListener('click', setClickPositionListener);
        };
    }, []);
    var titleToDisplay = getTitleToDisplay(t, title, privetEventsTitle, accessRole, extendedProps.isPrivate);
    if (DEMO_CALENDARS_IDS.includes(calendarId)) {
        titleToDisplay = t(title);
        summary = t(summary);
    }
    var expandedEventsProps = {
        copyLink: extendedProps.copyLink,
        startDate: extendedProps.startDate,
        endDate: extendedProps.endDate,
        location: extendedProps.location,
        locationLink: extendedProps.locationLink,
        summary: summary,
        recurrence: extendedProps.recurrence,
        attachments: extendedProps.attachments,
        isDetailsVisible: extendedProps.isDetailsVisible ||
            (extendedProps.isDetailsVisble && !extendedProps.isPrivate),
        type: extendedProps.type,
        // recurringEventId: extendedProps.recurringEventId,
        groupByStartDate: extendedProps.groupByStartDate,
        isPrivate: extendedProps.isPrivate,
        calendarId: calendarId,
        extendedProps: extendedProps,
        privetEventsTitle: privetEventsTitle,
        timeFormat: timeFormat,
        onCopyClick: onCopyClick,
        onLocationClick: onLocationClick,
        onAttachmentClick: onAttachmentClick,
        weekStarter: weekStarter,
        experiments: experiments,
        originType: '',
        calendarName: calendarName,
        accessRole: accessRole,
    };
    return (React.createElement(FocusTrap, null,
        React.createElement(Popper, { "aria-label": t('Google_Calendar_Expanded_EventDetails'), className: styles.Popper, open: open, anchorEl: anchorEl, placement: popoverLocation },
            React.createElement("div", { className: classes.EventWrapper },
                React.createElement(ClickAwayListener, { onClickAway: handleClickAway },
                    React.createElement(CalendarPopover, { closeAriaLabel: t('Google_Calendar_Expanded_Close'), className: st(classes.Event, { isMobile: isMobile }, 'CalendarPopover'), isShown: true, withArrow: false, title: React.createElement(ExpandedTitle, { eventColor: extendedProps.eventColor, title: titleToDisplay }), onClose: handleCloseClick, manualFocus: !isCloseFocused },
                        React.createElement(WeeklyExpandedEvent, { title: title, expandedEventsProps: expandedEventsProps, isMobile: false, locale: locale })))))));
};
export default React.memo(WeeklyPopper);
//# sourceMappingURL=WeeklyPopper.js.map